module.exports = [{
      plugin: require('../../node_modules/gatsby-plugin-mdx/gatsby-browser.js'),
      options: {"plugins":[],"extensions":[".mdx",".md"],"remarkPlugins":[null,null],"defaultLayouts":{"default":"/Users/arpit/dev/gatsby-theme-candor/theme/src/templates/Page.tsx","posts":"/Users/arpit/dev/gatsby-theme-candor/theme/src/templates/Post.tsx"},"gatsbyRemarkPlugins":[{"resolve":"gatsby-remark-images","options":{"maxWidth":800}},"gatsby-remark-prismjs"]},
    },{
      plugin: require('../../node_modules/gatsby-plugin-theme-ui/gatsby-browser.js'),
      options: {"plugins":[]},
    },{
      plugin: require('../../theme/gatsby-browser.js'),
      options: {"plugins":[]},
    }]
